import { DeepReadonly } from 'utility-types';
import { IClientScoreResult } from 'interfaces/scoreResult';
import { getTranslation } from '@pec/aion-ui-core/helpers/translation';

export const translateScoreResult = (
  scoreResult: DeepReadonly<IClientScoreResult>,
  language: string,
  clientName: string | null = null
) => {
  return {
    ...scoreResult,
    ...(clientName !== null ? { clientName } : {}),
    overallRanking: scoreResult.overallRanking
      ? {
          ...scoreResult.overallRanking,
          description: getTranslation(
            scoreResult.overallRanking.translations,
            language,
            scoreResult.overallRanking.description
          )
        }
      : scoreResult.overallRanking,
    scores: scoreResult.scores.map(score => ({
      ...score,
      scoreSetName: getTranslation(score.scoreSetNameTranslations, language, score.scoreSetName),
      rankingDescription: getTranslation(score.rankTranslations, language, score.rankingDescription)
    }))
  };
};
